A completed candidate submission for an `ApplicationQuestionnaire`.
